import HttpRequest from '@/http/HttpRequest'

const requestDy = new HttpRequest(process.env.VUE_APP_API_DY_BASE_URL)
export default requestDy
